module.exports = __webpack_public_path__ + "img/no-data.0bbdd9dd.svg";